import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ResponsiveDialog } from 'ui';
import { isInIframe } from 'utils/proxyUtils';
import { getSelectedSiteCollaborateInfo, getShowTaskCountModal, setShowTaskCountModal } from '../../../store/siteInfoSlice';
import GodaddyConfirmLessTaskModal from './less-task';
import GodaddyConfirmLargerTaskModal from './more-task';
import RedirectToDesignModal from './redirect-to-designhub';

export default function GodaddyConfirmTaskModal({ countValue }: { countValue: number | undefined }) {
    const dispatch = useDispatch();
    const itemDetails = useSelector(getSelectedSiteCollaborateInfo)

    const showTaskCountModal = useSelector(getShowTaskCountModal);

    const [openCloseConfirm, setOpenCloseConfirm] = useState(false);
    const [isLargeTask, setIsLargeTask] = useState(false);
    const [openDesignHubUrl, setOpenDesignHubUrl] = useState(false);



    const handleGodaddyDone = useCallback(() => {
        if (itemDetails?.result.website_care_url && itemDetails?.result.website_care_url !== '') {
            const websiteCareURL = itemDetails?.result.website_care_url
            try {
                window.parent.postMessage({
                    type: 'REDIRECT',
                    url: websiteCareURL
                }, '*');
            } catch (error) {
                window.location.href = itemDetails?.result.website_care_url;
                console.error('Error redirecting to website care URL:', error);
            }
        } else if (
            (itemDetails?.result.website_design_hub_url && itemDetails?.result.website_design_hub_url)
        ) {
            setOpenDesignHubUrl(true);
            setIsLargeTask(false);
            setOpenCloseConfirm(false);
        } else {
            if (isInIframe() && itemDetails?.result.account_id === 9458) {
                // Send message to parent for navigation
                window.parent.postMessage({
                    type: 'REDIRECT',
                    url: 'https://websitecare.godaddy.com'
                }, '*');
            } else {
                window.close();
            }
        }
    }, [itemDetails]);

    useEffect(() => {
        if (countValue) {
            if (countValue < 5) {
                setOpenCloseConfirm(true);
            } else if (countValue >= 50) {
                setIsLargeTask(true);
            } else {
                handleGodaddyDone();
            }
        } else {
            if (countValue === 0) {
                setOpenCloseConfirm(true);
            } else {
                handleGodaddyDone()
            }
        }

        return () => {
            setOpenCloseConfirm(false);
            setIsLargeTask(false);
        }
    }, [countValue, handleGodaddyDone]);



    const handleChange = (bool: boolean) => {
        dispatch(setShowTaskCountModal(bool));
    };

    return (
        <ResponsiveDialog open={showTaskCountModal} onOpenChange={handleChange}>
            {openCloseConfirm && <GodaddyConfirmLessTaskModal handleGodaddyDone={handleGodaddyDone} />}
            {isLargeTask && <GodaddyConfirmLargerTaskModal handleGodaddyDone={handleGodaddyDone} />}
            {openDesignHubUrl && <RedirectToDesignModal setOpenDesignHubUrl={setOpenDesignHubUrl} />}
        </ResponsiveDialog>
    );
}
